import {castToType, CastTypes} from '../utils/type-casting,util';
import * as immutable from 'immutable';

export class GeneralStoreEntity<T = any> {
    protected value: T;
    protected isArray: boolean;

    protected constructor(item: any) {
        this.value = item;
        this.constructor.prototype.valueOf = this.valueOf;
        return this;
    }

    private _originalValueType: any;

    get originalValueType(): any {
        return this._originalValueType;
    }

    set originalValueType(value: any) {
        this._originalValueType = value;
    }

    public static builder(payload): any {
        const instance = this;
        return new instance(payload);
    }

    public getValue() {
        return this.value;
    }

    public setValue(item: any) {
        this.value = item;
    }

    valueOf() {
        return this.value;
    }

    public upsert(state: any);
    public upsert(state: any, key: string);
    public upsert(state: any, key: string = null) {
        let value = key ? {[key]: this.valueOf()} : this.valueOf();
        return this.update(state, value);
    }

    public remove(state);
    public remove(state, key: string);
    public remove(state, key: string = null) {
        state = this.castToObject(state);
        if (key) {
            this.isArray ? state.splice(key, 1) : delete state[key];
        }
        else {
            state = null;
        }
        return this.castToOriginalType(state);
    }

    public init(state: any);
    public init(state: any, key: string);
    public init(state: any, key: string, initValue: any);
    public init(state: any, key: string = null, initValue: any = this.valueOf()) {
        initValue = Array.isArray(initValue) ? [...initValue] : {...initValue};
        return key
            ? {...state, [key]: initValue}
            : initValue;
    }

    protected update(state: any, value: any) {
        value = this.cast(value);
        state = this.cast(state);
        if (!value || (this.isArray && value && value.length === 0)) {
            state = value;
        }
        else {
            state = this.isArray ? [...(state || []), ...value] : Object.assign({}, state, value);
        }
        return this.castToOriginalType(state);

    }

    protected cast(value) {
        return typeof value === 'object' ? this.castToObject(value) : value;
    }

    protected castToObject(state: any = {}): object {
        this.originalValueType = state && state.constructor ? state.constructor.name : '';
        return this.castToArray(state) || castToType(CastTypes.OBJECT, state);
    }

    protected castToOriginalType(state: any) {
        return castToType(this.originalValueType, state, true);
    }

    protected castToArray(state) {
        this.isArray = true;
        if (immutable.List.isList(state) || immutable.Set.isSet(state)) {
            return state.toArray();
        }
        else if (Array.isArray(state)) {
            return [...state];
        }
        else {
            this.isArray = false;
            return null;
        }
    }


}
